<template>
  <div v-if="showOrientationWarning" class="orientation-overlay">
    <div class="orientation-content">
      <div class="phone-icon">
        <div class="phone-body">
          <div class="phone-screen"></div>
        </div>
        <div class="rotate-arrow">↻</div>
      </div>
      <h2 class="warning-title">{{ getWarningTexts().title }}</h2>
      <p class="warning-message">{{ getWarningTexts().message }}</p>
    </div>
  </div>
</template>

<script>
import orientationDetector from '@/utils/orientationDetection'
import Cookies from 'js-cookie'

export default {
  name: 'OrientationWarning',
  data() {
    return {
      showOrientationWarning: false,
      unsubscribe: null,
      warningTexts: {
        zh: {
          title: '請將裝置轉為直立',
          message: '為了獲得最佳體驗，請將您的裝置保持直立方向使用',
        },
        en: {
          title: 'Please Rotate to Portrait',
          message: 'For the best experience, please keep your device in portrait orientation',
        }
      }
    }
  },
  computed: {
    currentLanguage() {
      return Cookies.get('lang') || 'zh'
    }
  },
  mounted() {
    // 註冊方向改變監聽器
    this.unsubscribe = orientationDetector.onOrientationChange((isLandscape) => {
      this.showOrientationWarning = isLandscape
    })
    
    // 初始檢查
    this.showOrientationWarning = orientationDetector.getCurrentOrientation()
  },
  beforeUnmount() {
    // 取消監聽器
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  methods: {
    getWarningTexts() {
      return this.warningTexts[this.currentLanguage] || this.warningTexts.zh
    }
  },
  watch: {
    currentLanguage: {
      handler() {
        // 當語言改變時更新文字
        this.$forceUpdate()
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.orientation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #667eea 0%, #436ab2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.orientation-content {
  text-align: center;
  color: white;
  max-width: 90%;
}

.phone-icon {
  position: relative;
  margin: 0 auto 30px;
  width: 120px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-body {
  width: 50px;
  height: 80px;
  background: white;
  border-radius: 8px;
  position: relative;
  transform: rotate(90deg);
  animation: phone-shake 2s ease-in-out infinite;
}

.phone-screen {
  position: absolute;
  top: 8px;
  left: 6px;
  right: 6px;
  bottom: 8px;
  background: #333;
  border-radius: 4px;
}

.rotate-arrow {
  position: absolute;
  font-size: 3rem;
  color: #FFD700;
  animation: rotate-pulse 1.5s ease-in-out infinite;
  top: -10px;
  right: -20px;
}

.warning-title {
  font-size: 2rem;
  font-weight: bold;
  margin: 0 0 20px 0;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.warning-message {
  font-size: 1.2rem;
  line-height: 1.6;
  margin: 0 0 30px 0;
  opacity: 0.9;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.orientation-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255,255,255,0.1);
  padding: 15px 25px;
  border-radius: 25px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.2);
}

.hint-icon {
  font-size: 1.5rem;
  animation: icon-bounce 2s ease-in-out infinite;
}

.hint-text {
  font-size: 1.1rem;
  font-weight: 500;
}

/* 動畫效果 */
@keyframes phone-shake {
  0%, 100% {
    transform: rotate(90deg) translateY(0px);
  }
  25% {
    transform: rotate(85deg) translateY(-2px);
  }
  75% {
    transform: rotate(95deg) translateY(2px);
  }
}

@keyframes rotate-pulse {
  0%, 100% {
    transform: rotate(0deg) scale(1);
    opacity: 0.7;
  }
  50% {
    transform: rotate(180deg) scale(1.2);
    opacity: 1;
  }
}

@keyframes icon-bounce {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* 響應式設計 */
@media screen and (max-height: 500px) {
  .warning-title {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }
  
  .warning-message {
    font-size: 1rem;
    margin-bottom: 20px;
  }
  
  .phone-icon {
    margin-bottom: 20px;
    transform: scale(0.8);
  }
  
  .orientation-hint {
    padding: 10px 20px;
  }
}

/* 英文版本的字體調整 */
.orientation-content[data-lang="en"] .warning-title {
  font-size: 1.8rem;
  line-height: 1.2;
}

.orientation-content[data-lang="en"] .warning-message {
  font-size: 1.1rem;
}
</style>